import { render } from "./RefreshPassword.vue?vue&type=template&id=78317a6a&scoped=true"
import script from "./RefreshPassword.vue?vue&type=script&lang=js"
export * from "./RefreshPassword.vue?vue&type=script&lang=js"

import "./RefreshPassword.vue?vue&type=style&index=0&id=78317a6a&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78317a6a"]])

export default __exports__